<!-- Toast Notification -->
<div class="toast-msg-container" *ngIf="showToast">
    <div class="toast-msg" [style.backgroundColor]="isSuccess ? '#73d76a' : '#f54b4b'">
        {{ notificationMsg }}
    </div>
</div>

<!-- Loading Spinner -->
<div *ngIf="isLoading" class="loading">
    <div class="spinner-border m-auto" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<!-- Main Content -->
<div *ngIf="!isLoading" class="p-3" style="background-color: white; min-height: 100%;">
    <div class="d-flex flex-column py-2">

        <!-- Section Header -->
        <div class="d-flex align-items-center justify-content-between">
            <div style="color: #757575; font-size: 18px; font-weight: 600;">Social Profiles</div>
            <div class="d-flex align-items-center justify-content-end">
                <button class="ml-1" [ngClass]="isEdit ? 'cancel-btn': 'edit-btn'" (click)="isEdit ? cancelEdit() : editBtnClicked()">
                    {{ isEdit ? 'Cancel' : 'Edit' }}
                </button>
                <button (click)="submitSocialProfiles()" class="edit-btn ml-1" *ngIf="isEdit">Save</button>
            </div>
        </div>

        <ng-container>
            <form [formGroup]="socialProfilesForm">
                <div class="d-flex flex-column mt-2" style="gap: 0.5rem;">
                    <!-- Facebook -->
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Facebook :</div>
                        <input type="text" class="form-control input-field" formControlName="facebook" placeholder="--" />
                        <small class="text-danger mb-2" *ngIf="socialProfilesForm.get('facebook')?.hasError('invalidUrl')">
                            Invalid Facebook URL
                        </small>
                    </div>

                    <!-- YouTube -->
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">YouTube :</div>
                        <input type="text" class="form-control input-field" formControlName="youtube" placeholder="--" />
                        <small class="text-danger mb-2" *ngIf="socialProfilesForm.get('youtube')?.hasError('invalidUrl')">
                            Invalid YouTube URL
                        </small>
                    </div>

                    <!-- Email -->
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Email :</div>
                        <input type="email" class="form-control input-field" formControlName="gmail" placeholder="--" />
                    </div>

                    <!-- Instagram -->
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Instagram :</div>
                        <input type="text" class="form-control input-field" formControlName="instagram" placeholder="--" />
                        <small class="text-danger mb-2" *ngIf="socialProfilesForm.get('instagram')?.hasError('invalidUrl')">
                            Invalid Instagram URL
                        </small>
                    </div>

                    <!-- Google Business -->
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Google Business :</div>
                        <input type="text" class="form-control input-field" formControlName="googleBusiness" placeholder="--" />
                        <small class="text-danger mb-2" *ngIf="socialProfilesForm.get('googleBusiness')?.hasError('invalidUrl')">
                            Invalid Google Business URL
                        </small>
                    </div>

                    <!-- External Website -->
                    <div class="d-flex flex-column" style="font-size: 14px;">
                        <div style="color: #673AB7; font-size: 13px;">Website :</div>
                        <input type="text" class="form-control input-field" formControlName="externalWebsite" placeholder="--" />
                        <small class="text-danger mb-2" *ngIf="socialProfilesForm.get('externalWebsite')?.hasError('invalidUrl')">
                            Invalid Website URL
                        </small>
                    </div>
                </div>
            </form>
        </ng-container>
    </div>
</div>
